import React, { useState } from "react";
import {
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage } from "../../lib/index";
import { useReligionContext } from "../../context/ReligionContext";
import { GiPrayerBeads } from "react-icons/gi";

const Add = () => {
  const { createOneReligion } = useReligionContext();

  let [error, setError] = useState(false);
  let [status, setStatus] = useState(0);
  let [message, setErrorMessage] = useState("");
  let [loading, setLoading] = useState(false);
  let [success, setSuccess] = useState(false);

  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);

  const religionRoutes = "/religion";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setName(null);
    setDescription(null);
  };

  const responses = (isError: any, status: any, message: any) => {
    setError(isError);
    setStatus(status);
    setErrorMessage(message);
  };

  const addOneReligionHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name: name, description: description };
    const response = await createOneReligion(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={religionRoutes}
      eyebrow="Catalog • Religions"
      title="Add Religion"
      subtitle="Add a religion entry that travellers can recognise across the platform."
      icon={<GiPrayerBeads className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Add Religion"
      onSubmit={addOneReligionHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Religion Details"
        hint="Use the official name where possible to avoid duplicates."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <div className="md:col-span-2">
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                required: true,
                value: description ? description : "",
                onChange: (e: any) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
